import { h } from 'preact';
import { Text } from 'preact-i18n';
import { selectIcon } from '../../../templates/place';
import MundialButton from '../../MundialButton';

const DateOption = ({ label, onClick, icon }) => {
  const handleClick = (e) => {
    e.stopPropagation(); // Prevent event from bubbling to parent wrapper
    onClick(e);
  };
  
  return (
    <button className="dates-controls-button" onClick={handleClick}>
      {icon && (
        <div
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{
            __html: selectIcon('calendar', false),
          }}
        />
      )}
      {label}
    </button>
  );
};

const DatesControls = ({ label, onDateClick, onTodayClick, onTomorrowClick, onMundialClick, showMundialButton = false, showTomorrowWithMundial = true }) => {
  // Show Tomorrow button always, and Mundial button additionally when showMundialButton is true
  // The showTomorrowWithMundial flag controls if Tomorrow is shown when Mundial is active (for future flexibility)
  const shouldShowTomorrow = !showMundialButton || showTomorrowWithMundial;
  
  return (
    <div className="dates-controls-container">
      <label className="label">{label}</label>
      <div className="dates-controls-wrapped">
        <DateOption label={<Text id="label.today" />} onClick={onTodayClick} />
        {shouldShowTomorrow && <DateOption label={<Text id="label.tomorrow" />} onClick={onTomorrowClick} />}
        {showMundialButton && <MundialButton onClick={onMundialClick} />}
        <DateOption label={<Text id="label.select" />} icon="calendar" onClick={onDateClick} />
      </div>
    </div>
  );
};

export default DatesControls;

